import { Directive, Input } from '@angular/core';
import { CheckBoxAppearance, CheckboxInputDirective } from './input-checkbox.directive';

@Directive({
  standalone: true,
  selector: `
    input[type="radio"][vsInput],
  `,
})
export class RadioInputDirective extends CheckboxInputDirective {
  @Input() override appearance: CheckBoxAppearance = 'radio';
}
